/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const PowerPointDoc72Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 72, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="PowerPointDoc72Icon"
        width="72"
        height="72"
        viewBox="0 0 72 72"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M15 36V12C15 10.8954 15.8954 10 17 10H39.1716C39.702 10 40.2107 10.2107 40.5858 10.5858L57.4142 27.4142C57.7893 27.7893 58 28.298 58 28.8284V36M40 10.5V26C40 27.1046 40.8954 28 42 28H57.5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <g opacity="0.4">
            <path
              d="M16 43.584C16 43.248 16.024 42.976 16.072 42.768C16.136 42.56 16.248 42.4 16.408 42.288C16.568 42.176 16.792 42.104 17.08 42.072C17.384 42.024 17.776 42 18.256 42H21.64C22.696 42 23.584 42.088 24.304 42.264C25.04 42.44 25.64 42.736 26.104 43.152C26.568 43.568 26.904 44.12 27.112 44.808C27.32 45.48 27.424 46.312 27.424 47.304C27.424 48.296 27.312 49.144 27.088 49.848C26.864 50.552 26.52 51.128 26.056 51.576C25.592 52.024 24.992 52.352 24.256 52.56C23.536 52.768 22.664 52.872 21.64 52.872H19.12V57.72C19.12 58.04 19 58.328 18.76 58.584C18.52 58.84 18.12 58.968 17.56 58.968C17 58.968 16.6 58.832 16.36 58.56C16.12 58.288 16 58.008 16 57.72V43.584ZM19.12 50.184H21.64C22.664 50.184 23.36 49.96 23.728 49.512C24.112 49.064 24.304 48.336 24.304 47.328C24.304 46.8 24.232 46.368 24.088 46.032C23.96 45.696 23.776 45.432 23.536 45.24C23.296 45.032 23.016 44.896 22.696 44.832C22.376 44.752 22.024 44.712 21.64 44.712H19.12V50.184Z"
              fill="currentColor"
            />
            <path
              d="M30.2547 43.584C30.2547 43.248 30.2787 42.976 30.3267 42.768C30.3907 42.56 30.5027 42.4 30.6627 42.288C30.8227 42.176 31.0467 42.104 31.3347 42.072C31.6387 42.024 32.0307 42 32.5107 42H35.8947C36.9507 42 37.8387 42.088 38.5587 42.264C39.2947 42.44 39.8947 42.736 40.3587 43.152C40.8227 43.568 41.1587 44.12 41.3667 44.808C41.5747 45.48 41.6787 46.312 41.6787 47.304C41.6787 48.296 41.5667 49.144 41.3427 49.848C41.1187 50.552 40.7747 51.128 40.3107 51.576C39.8467 52.024 39.2467 52.352 38.5107 52.56C37.7907 52.768 36.9187 52.872 35.8947 52.872H33.3747V57.72C33.3747 58.04 33.2547 58.328 33.0147 58.584C32.7747 58.84 32.3747 58.968 31.8147 58.968C31.2547 58.968 30.8547 58.832 30.6147 58.56C30.3747 58.288 30.2547 58.008 30.2547 57.72V43.584ZM33.3747 50.184H35.8947C36.9187 50.184 37.6147 49.96 37.9827 49.512C38.3667 49.064 38.5587 48.336 38.5587 47.328C38.5587 46.8 38.4867 46.368 38.3427 46.032C38.2147 45.696 38.0307 45.432 37.7907 45.24C37.5507 45.032 37.2707 44.896 36.9507 44.832C36.6307 44.752 36.2787 44.712 35.8947 44.712H33.3747V50.184Z"
              fill="currentColor"
            />
            <path
              d="M51.4694 44.784V57.72C51.4694 58.04 51.3494 58.328 51.1094 58.584C50.8694 58.84 50.4694 58.968 49.9094 58.968C49.3494 58.968 48.9494 58.832 48.7094 58.56C48.4694 58.288 48.3494 58.008 48.3494 57.72V44.784H45.2774C44.9894 44.784 44.7094 44.68 44.4374 44.472C44.1654 44.264 44.0294 43.904 44.0294 43.392C44.0294 42.896 44.1574 42.544 44.4134 42.336C44.6694 42.112 44.9574 42 45.2774 42H54.5414C54.8614 42 55.1494 42.112 55.4054 42.336C55.6614 42.544 55.7894 42.896 55.7894 43.392C55.7894 43.904 55.6534 44.264 55.3814 44.472C55.1094 44.68 54.8294 44.784 54.5414 44.784H51.4694Z"
              fill="currentColor"
            />
          </g>
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

PowerPointDoc72Icon.tags = [
  'powerpoint',
  'document',
  'ppt',
  'file',
  'presentation',
];

PowerPointDoc72Icon.category = '72x72 (File types)';

PowerPointDoc72Icon.iconSize = 72;
